import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Core } from "@faire/design-tokens";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getUserToken } from "@faire/help-center-utils/serialized-data/getUser";
import { getSettingPhoneCallbackAttachment } from "@faire/help-center-utils/settings/getSettingPhoneCallbackAttachment";
import { useMutation as usePhoneCallbackMutation } from "@faire/web-api/api/help-center/phone/callback_request/post-hooks";
import { trackCxFoundationsEmailUsPageView } from "@faire/web-api/events/cxFoundations/view/emailUsPage";
import { trackHelpCenterEditPhoneNumberClick } from "@faire/web-api/events/helpCenter/click/editPhoneNumber";
import { trackHelpCenterAllTypesOfTicketCreationSubmit } from "@faire/web-api/events/helpCenter/submit/allTypesOfTicketCreation";
import { trackHelpCenterPhoneSupportSubmit } from "@faire/web-api/events/helpCenter/submit/phoneSupport";
import { trackHelpCenterCallRequestView } from "@faire/web-api/events/helpCenter/view/callRequest";
import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import { IHCPhoneCallbackRequest } from "@faire/web-api/indigofair/helpcenter/IHCPhoneCallbackRequest";
import { useStrictLocalization } from "@faire/web/common/localization";
import { PhoneInput } from "@faire/web/slate-labs/Input/PhoneInput";
import { Button } from "@faire/web/slate/Button";
import { TextArea } from "@faire/web/slate/Input/TextArea";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { BackButton } from "../../components/BackButton";
import { TicketType } from "../../consts";
import { useEditSettingsLink } from "../../hooks/useEditSettingsLink";
import { useInitializeCallRequestField } from "../../hooks/useInitializeCallRequestField";
import { useIssueType } from "../../hooks/useIssueType";
import { useNavigation } from "../../hooks/useNavigation";
import { useScrollToTopOnLoadEffect } from "../../hooks/useScrollToTopEffect";
import { useTrackPageViewEffect } from "../../hooks/useTrackPageViewEffect";
import { LimitedWidthWrapper } from "../components/LimitedWidthWrapper";
import { AttachmentFormField } from "../Email/AttachmentFormField";
import { getCallRequestTicketPayload } from "./getCallRequestTicketPayload";
import { PhoneNumberErrorMessage } from "./PhoneNumberErrorMessage";
export var Phone = function Phone() {
  var _getRetailerToken, _getBrandToken, _getUserToken;
  useTrackPageViewEffect(trackCxFoundationsEmailUsPageView);
  useScrollToTopOnLoadEffect(10);
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var _useIssueType = useIssueType(),
    issueType = _useIssueType.issueType;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    attachment = _useState2[0],
    setAttachment = _useState2[1];
  var retailerToken = (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "";
  var brandToken = (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "";
  var userToken = (_getUserToken = getUserToken()) !== null && _getUserToken !== void 0 ? _getUserToken : "";
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    hasPhoneInputError = _useState8[0],
    setHasPhoneInputError = _useState8[1];
  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    details = _useState10[0],
    setDetails = _useState10[1];
  var _usePhoneCallbackMuta = usePhoneCallbackMutation(),
    mutatePhoneCallback = _usePhoneCallbackMuta.mutate;
  var _useInitializeCallReq = useInitializeCallRequestField(),
    callRequestInitial = _useInitializeCallReq.callRequestInitial;
  var phoneNumber = callRequestInitial.phone;
  var _useNavigation = useNavigation(),
    goToNextStep = _useNavigation.goToNextStep;
  var editSettingsLink = useEditSettingsLink();
  useEffect(function () {
    trackHelpCenterCallRequestView(retailerToken, brandToken);
  }, [brandToken, retailerToken]);
  useEffect(function () {
    if (!phoneNumber) {
      setHasPhoneInputError(true);
    } else {
      setHasPhoneInputError(false);
    }
  }, [phoneNumber]);
  var handleEditSettingsClick = function handleEditSettingsClick() {
    var _getRetailerToken2, _getBrandToken2;
    trackHelpCenterEditPhoneNumberClick((_getRetailerToken2 = getRetailerToken()) !== null && _getRetailerToken2 !== void 0 ? _getRetailerToken2 : "", (_getBrandToken2 = getBrandToken()) !== null && _getBrandToken2 !== void 0 ? _getBrandToken2 : "");
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref2, _ref3, callRequestPayload, _getCallRequestTicket, phoneTicketPayload, brand_order_token, phone_number, email, subject, description, issue_type, platform, os_version, app_version, tags;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            _context.prev = 1;
            if (!hasPhoneInputError) {
              _context.next = 6;
              break;
            }
            setIsLoading(false);
            setErrorMessage(strictLocalize({
              id: "rxRRpv",
              defaultMessage: [{
                "type": 0,
                "value": "Adicione um número de telefone nas definições de conta."
              }]
            }));
            return _context.abrupt("return");
          case 6:
            callRequestPayload = _objectSpread(_objectSpread({}, callRequestInitial), {}, {
              phone: phoneNumber,
              details: details
            });
            _getCallRequestTicket = getCallRequestTicketPayload({
              values: callRequestPayload,
              issueType: issueType
            }), phoneTicketPayload = _getCallRequestTicket.phoneTicketPayload;
            brand_order_token = phoneTicketPayload.brand_order_token, phone_number = phoneTicketPayload.phone_number, email = phoneTicketPayload.email, subject = phoneTicketPayload.subject, description = phoneTicketPayload.description, issue_type = phoneTicketPayload.issue_type, platform = phoneTicketPayload.platform, os_version = phoneTicketPayload.os_version, app_version = phoneTicketPayload.app_version, tags = phoneTicketPayload.tags; // Try use Phone callback API prototype
            mutatePhoneCallback([IHCPhoneCallbackRequest.build({
              phone_number: phoneNumber,
              customer_token: (_ref2 = (_ref3 = retailerToken !== null && retailerToken !== void 0 ? retailerToken : brandToken) !== null && _ref3 !== void 0 ? _ref3 : userToken) !== null && _ref2 !== void 0 ? _ref2 : "",
              brand_order_token: brand_order_token,
              issue_type: issue_type,
              platform: platform,
              os_version: os_version,
              app_version: app_version,
              tags: tags.filter(function (tag) {
                return tag !== "";
              }).join(", "),
              description: description
            })]);
            trackHelpCenterPhoneSupportSubmit(retailerToken, brandToken, brand_order_token !== null && brand_order_token !== void 0 ? brand_order_token : "", phone_number !== null && phone_number !== void 0 ? phone_number : "", email !== null && email !== void 0 ? email : "", subject !== null && subject !== void 0 ? subject : "", description !== null && description !== void 0 ? description : "", details !== null && details !== void 0 ? details : "", userToken);
            trackHelpCenterAllTypesOfTicketCreationSubmit(retailerToken, brandToken, brand_order_token !== null && brand_order_token !== void 0 ? brand_order_token : "", email !== null && email !== void 0 ? email : "", phone_number !== null && phone_number !== void 0 ? phone_number : "", subject !== null && subject !== void 0 ? subject : "", details !== null && details !== void 0 ? details : "", issueType, TicketType.PHONE, "", "", description !== null && description !== void 0 ? description : "", userToken);
            setIsLoading(false);
            goToNextStep({
              supportType: "phone"
            });
            setErrorMessage("");
            _context.next = 21;
            break;
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](1);
            setErrorMessage(strictLocalize({
              id: "yYs9yf",
              defaultMessage: [{
                "type": 0,
                "value": "Ocorreu um erro. Tente novamente. Ou contacte-nos por e-mail."
              }]
            }));
            setIsLoading(false);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 17]]);
    }));
    return function handleSubmit() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(LimitedWidthWrapper, null, /*#__PURE__*/React.createElement(BackButton, null), /*#__PURE__*/React.createElement(Spacer, {
    height: "4x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "sectionHeaderSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "JlKuGe",
    defaultMessage: [{
      "type": 0,
      "value": "Solicitar uma chamada"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "IaD3r6",
    defaultMessage: [{
      "type": 0,
      "value": "Preencha este formulário e iremos ligar para o número indicado abaixo. O tempo médio de espera é de 3 minutos."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "4x"
  }), /*#__PURE__*/React.createElement(InputWrapper, null, /*#__PURE__*/React.createElement(PhoneInput, {
    "data-test-id": "call-request-phone-number-input",
    name: "phoneNumber",
    label: /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "HHgT62",
      defaultMessage: [{
        "type": 0,
        "value": "Número de telefone da conta"
      }]
    }),
    defaultPhoneNumber: phoneNumber,
    error: hasPhoneInputError ? /*#__PURE__*/React.createElement(PhoneNumberErrorMessage, null) : undefined,
    disabled: true,
    sideCta: /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: editSettingsLink,
      onClick: handleEditSettingsClick,
      target: "_blank"
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "+KV3TC",
      defaultMessage: "Edit settings"
    }))
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(InputWrapper, null, /*#__PURE__*/React.createElement(TextArea, {
    style: {
      height: "120px"
    },
    label: strictLocalize({
      id: "Gpu47L",
      defaultMessage: [{
        "type": 0,
        "value": "Informações sobre o problema (opcional)"
      }]
    }),
    value: details,
    onChange: function onChange(e) {
      return setDetails(e.target.value);
    }
  })), getSettingPhoneCallbackAttachment() ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(AttachmentFormField, {
    attachment: attachment,
    setAttachment: setAttachment
  }))) : null, /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(Button, {
    style: {
      width: "160px",
      height: "56px"
    },
    onClick: handleSubmit,
    "data-test-id": "request-call-btn"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "wav36q",
    defaultMessage: "Request call"
  })), errorMessage && !isLoading ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    height: "1/2x"
  }), /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.critical
  }, errorMessage))) : null, /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "labelSansRegular",
    color: Core.text.subdued
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "FTwGy2",
    defaultMessage: [{
      "type": 0,
      "value": "Ao pedir uma chamada, concorda com a gravação de chamadas que utilizamos para melhorar o nosso apoio ao cliente."
    }]
  })));
};
var InputWrapper = styled.div.withConfig({
  displayName: "Phone__InputWrapper"
})(["width:100%;"]);